const workPermitValues = [
  { value: 'No', label: 'No' },
  { value: 'Yes', label: 'Yes' }
];

export default workPermitValues;
